<template>
  <div id="vue-request-quote-form" style="
    display:none;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0) 30%,rgba(0,0,0,0.8) 100%),url(/wp-content/plugins/autotaksering/requests/assets/img/workshop.jpg);
    "
       :style="$root.styleObject" :class="['vue-rqf-wrap', $route.name ]">
    <div v-if="!$root.ui.thanks">
      <div class="bg-loading" :loading="$root.ui.loading">
        <router-view></router-view>
      </div>
      <modal v-if="$root.ui.modal.show" @close="$root.ui.modal.show = false">
        <h3 slot="header" v-text="$root.ui.modal.message"></h3>
      </modal>
      <lightbox v-if="$root.ui.lightbox.show" @close="$root.hideUILightbox()">
        <div slot="body">
          <ul>
            <li><img src="/wp-content/plugins/autotaksering/requests/assets/img/fixtures/eksempel1.jpg" /></li>
          </ul>

        </div>
      </lightbox>
    </div>
    <div v-else>
      <div class="div thanks__container">
        <div class="thanks__content eltdf-row-grid-section">
          <div class="vc_column_container">
            <div class="vc_column-inner">
              <span>Takk skal du ha.</span>
               <span>Vi har sendt forespørselen din og vil kontakte deg snart.</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

  import 'vue2-datepicker/index.css';
  export default {
    name: 'app',

    data () {
      return {}
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// App.vue?6e8853dd